var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3248.331,
    height: 1412.992,
    viewBox: "0 0 3248.331 1412.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(287.028 371.691) rotate(-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64773",
    "data-name": "Tracciato 64773",
    d: "M-161.919,384.709C-40.047,252.842,153.108,205.01,331.8,222.584c58.837,5.787,118.488,18.461,168.431,50.1C623.309,350.642,652.154,513.9,723,641.2c115.865,208.2,357.149,323.857,594.742,341.827,165,12.479,342.467-20.956,463.12-134.2,188.528-176.955,192.4-497.718,395.247-658.062,77.4-61.184,178.718-91.246,276.963-82.175",
    transform: "translate(42.537 0)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64774",
    "data-name": "Tracciato 64774",
    d: "M2467.821,138.142c-70.029-9.537-144.334,2.166-209.371,32.183a372.929,372.929,0,0,0-62.084,36.224c-106.646,77.065-160.494,197.395-216.229,319.338C1930.266,634.909,1879.149,745.38,1788.6,826a467.913,467.913,0,0,1-91.824,63.566c-111.129,59.119-245.478,77.835-372.686,70.373a914.236,914.236,0,0,1-95.288-10.627c-204.5-33.789-399.379-137.727-504.058-308.986-73.934-120.9-107.609-276.65-231.78-350.992-50.392-30.168-110.112-42.21-169.054-47.728a769.483,769.483,0,0,0-99.289-2.861c-148.112,5.344-296.3,53.664-394.973,151.83",
    transform: "translate(40.836 5.632)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64775",
    "data-name": "Tracciato 64775",
    d: "M2482.572,167.807c-66.53-12.286-139.893-4.011-204.312,22.335a365.528,365.528,0,0,0-61.635,32.3c-106.2,69.477-162.265,180.771-221.109,295.35-52.69,102.419-107.074,207.781-199.167,285.488a494,494,0,0,1-92.816,61.571c-111.945,57.666-245.949,77.4-373.085,72.1a947.254,947.254,0,0,1-95.244-8.794c-204.37-29.437-399.7-126.413-508.705-288.608C649.474,525.069,610.971,376.82,485.7,306.1c-50.843-28.7-110.63-40.109-169.677-45.357a817.18,817.18,0,0,0-99.449-2.763c-148.282,4.96-297.543,49.957-395.35,138.578",
    transform: "translate(39.134 11.151)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64776",
    "data-name": "Tracciato 64776",
    d: "M2497.323,197.6c-63.032-15.033-135.453-10.186-199.253,12.488a360.389,360.389,0,0,0-61.185,28.383c-105.76,61.891-164.038,164.147-225.99,271.362-55.509,95.817-113.159,196.07-206.8,270.863a524.143,524.143,0,0,1-93.806,59.576c-112.761,56.212-246.42,76.969-373.484,73.835-31.768-.78-63.589-3.094-95.2-6.96-204.24-25.084-400.018-115.1-513.352-268.229C648.135,530.834,604.8,390.089,478.436,322.985c-51.292-27.229-111.148-38.008-170.3-42.987a870.54,870.54,0,0,0-99.609-2.665C60.072,281.909-90.265,323.583-187.2,402.658",
    transform: "translate(37.433 16.547)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64777",
    "data-name": "Tracciato 64777",
    d: "M2512.075,227.521c-59.534-17.783-131.013-16.363-194.194,2.639a358.058,358.058,0,0,0-60.737,24.462c-105.317,54.3-165.809,147.525-230.871,247.373-58.326,89.215-119.244,184.361-214.436,256.24a559.651,559.651,0,0,1-94.8,57.581c-113.579,54.759-246.891,76.535-373.883,75.567-31.752-.239-63.553-1.936-95.155-5.127-204.111-20.732-400.338-103.783-518-247.849-83.208-101.674-131.368-234.913-258.833-298.4C419.427,314.249,359.5,304.1,300.246,299.392a931.327,931.327,0,0,0-99.769-2.567C51.851,301.017-99.562,339.367-195.628,408.9",
    transform: "translate(35.731 21.806)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64778",
    "data-name": "Tracciato 64778",
    d: "M2526.827,257.594c-56.036-20.532-126.573-22.539-189.135-7.209a358.642,358.642,0,0,0-60.288,20.542c-104.874,46.717-167.581,130.9-235.752,223.384-61.143,82.613-125.33,172.651-222.071,241.616a601.439,601.439,0,0,1-95.789,55.586c-114.395,53.3-247.363,76.1-374.282,77.3-31.736.3-63.517-.779-95.109-3.293-203.983-16.378-400.659-92.468-522.649-227.47-86.3-95.266-139.287-221-267.851-280.867-52.191-24.292-112.183-33.806-171.545-38.247-33.055-2.47-66.5-3.321-99.929-2.469-148.8,3.806-301.287,38.833-396.484,98.819",
    transform: "translate(34.03 26.917)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64779",
    "data-name": "Tracciato 64779",
    d: "M2541.579,287.827c-52.539-23.281-122.134-28.715-184.077-17.056a362.9,362.9,0,0,0-59.837,16.621c-104.432,39.129-169.354,114.279-240.633,199.4C1993.07,562.8,1925.616,647.729,1827.325,713.78a651.415,651.415,0,0,1-96.78,53.59c-115.211,51.851-247.833,75.668-374.681,79.03-31.721.844-63.482.377-95.064-1.459-203.854-12.027-400.979-81.155-527.3-207.091C644.114,548.991,586.3,430.761,456.634,374.514c-52.641-22.823-112.7-31.7-172.169-35.877-33.118-2.321-66.614-3.137-100.086-2.371-148.971,3.423-302.537,35.127-396.862,85.568",
    transform: "translate(32.328 31.867)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64780",
    "data-name": "Tracciato 64780",
    d: "M2556.329,318.235c-49.04-26.03-117.693-34.891-179.017-26.9a371.329,371.329,0,0,0-59.388,12.7c-103.989,31.542-171.125,97.656-245.514,175.407-66.779,69.41-137.5,149.231-237.34,212.369A711.652,711.652,0,0,1,1737.3,743.4c-116.027,50.4-248.3,75.237-375.08,80.762-31.705,1.387-63.446,1.535-95.02.375-203.724-7.675-401.3-69.84-531.944-186.712-92.479-82.453-155.127-193.177-285.886-245.8-53.092-21.354-113.219-29.6-172.793-33.507-33.182-2.171-66.725-2.952-100.246-2.273C27.188,359.28-127.455,387.66-220.91,428.556",
    transform: "translate(30.627 36.644)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64781",
    "data-name": "Tracciato 64781",
    d: "M2571.081,348.827c-45.542-28.778-113.253-41.067-173.958-36.752a384.752,384.752,0,0,0-58.939,8.78c-103.546,23.955-172.9,81.033-250.395,151.418-69.6,62.808-143.586,137.521-244.974,197.745a785.524,785.524,0,0,1-98.764,49.6c-116.842,48.944-248.773,74.8-375.478,82.494-31.688,1.928-63.41,2.691-94.974,2.208C1070,801,871.979,745.794,737,637.987c-95.57-76.046-163.047-179.265-294.9-228.274-53.542-19.885-113.736-27.5-173.415-31.137-33.247-2.022-66.835-2.768-100.406-2.174-149.314,2.654-305.032,27.71-397.617,59.062",
    transform: "translate(28.925 41.235)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64782",
    "data-name": "Tracciato 64782",
    d: "M2585.833,379.617c-42.045-31.527-108.813-47.243-168.9-46.6a404.272,404.272,0,0,0-58.49,4.861c-103.1,16.366-174.669,64.409-255.277,127.429-72.415,56.206-149.67,125.809-252.607,183.121a878.241,878.241,0,0,1-99.756,47.6c-117.658,47.491-249.245,74.37-375.877,84.224-31.672,2.47-63.374,3.849-94.93,4.042-203.465,1.03-401.939-47.211-541.24-145.953C640.1,568.707,567.79,472.992,434.834,427.6,380.842,409.185,320.58,402.2,260.8,398.835c-33.311-1.87-66.946-2.582-100.566-2.076-149.485,2.27-306.281,24-398,45.809",
    transform: "translate(27.224 45.629)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64783",
    "data-name": "Tracciato 64783",
    d: "M2600.584,410.635c-38.547-34.276-104.373-53.419-163.841-56.449a431.356,431.356,0,0,0-58.04.941c-102.661,8.779-176.442,47.786-260.158,103.441-75.233,49.6-155.757,114.1-260.243,168.5a996.265,996.265,0,0,1-100.746,45.609c-118.475,46.036-249.716,73.938-376.277,85.956q-47.484,4.518-94.884,5.875c-203.336,5.383-402.259-35.9-545.888-125.574C638.756,575.7,561.621,487.491,427.567,445.72c-54.441-16.948-114.771-23.3-174.661-26.4-33.376-1.721-67.057-2.4-100.725-1.977-149.657,1.886-307.528,20.3-398.373,32.556",
    transform: "translate(25.522 49.795)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64784",
    "data-name": "Tracciato 64784",
    d: "M2615.335,441.976c-35.047-37.025-99.932-59.6-158.782-66.3a467.283,467.283,0,0,0-57.591-2.98c-102.217,1.192-178.213,31.163-265.038,79.452-78.05,43-161.842,102.39-267.877,153.874-32.536,15.929-66.66,30.451-101.738,43.614-119.291,44.583-250.187,73.5-376.676,87.687q-47.46,5.331-94.839,7.709c-203.207,9.735-402.58-24.58-550.536-105.2C637.415,583.016,555.452,502.313,420.3,464.159c-54.891-15.478-115.289-21.2-175.284-24.027-33.438-1.571-67.166-2.213-100.884-1.88-149.829,1.5-308.777,16.589-398.751,19.3",
    transform: "translate(23.821 53.639)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64785",
    "data-name": "Tracciato 64785",
    d: "M2630.087,473.747c-31.55-39.775-95.492-65.772-153.723-76.145a514.18,514.18,0,0,0-57.141-6.9c-101.775-6.4-179.9,14.723-269.92,55.463-80.793,36.565-167.928,90.68-275.511,139.25-32.986,15.024-67.434,28.891-102.729,41.618-120.107,43.129-250.658,73.071-377.075,89.419q-47.437,6.142-94.794,9.542c-203.077,14.088-402.9-13.265-555.184-84.816C636.076,590.762,549.283,517.563,413.033,483.029c-55.34-14.009-115.806-19.1-175.907-21.657-33.5-1.422-67.277-2.029-101.044-1.781-150,1.118-310.025,12.88-399.128,6.052",
    transform: "translate(22.119 57.052)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64786",
    "data-name": "Tracciato 64786",
    d: "M2644.839,506.1c-28.052-42.522-91.053-71.947-148.665-85.993a574.9,574.9,0,0,0-56.691-10.821c-101.332-13.983-181.689-1.894-274.8,31.474-83.625,29.969-174.013,78.97-283.147,124.626-33.435,14.118-68.208,27.331-103.719,39.623-120.923,41.675-251.129,72.637-377.474,91.15q-47.413,6.957-94.75,11.377c-202.947,18.44-403.219-1.952-559.832-64.438C634.736,599.1,543.114,533.4,405.767,502.487c-55.791-12.541-116.324-17-176.531-19.287-33.567-1.272-67.387-1.845-101.2-1.684-150.172.734-311.272,9.173-399.506-7.2",
    transform: "translate(20.418 59.878)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64787",
    "data-name": "Tracciato 64787",
    d: "M2659.591,539.146c-24.555-45.272-86.613-78.124-143.606-95.841-19.113-5.9-37.909-10.833-56.243-14.741-100.888-21.569-183.528-18.706-279.68,7.485-86.5,23.2-180.1,67.26-290.781,110-33.885,13.213-68.983,25.771-104.711,37.627A2519.5,2519.5,0,0,1,1406.7,676.562q-47.39,7.768-94.7,13.21c-202.819,22.792-403.54,9.363-564.481-44.058C633.4,608.111,536.946,549.923,398.5,522.627c-56.241-11.072-116.842-14.9-177.153-16.917-33.632-1.123-67.5-1.66-101.364-1.585-150.344.35-312.521,5.465-399.884-20.454",
    transform: "translate(18.716 62.021)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64788",
    "data-name": "Tracciato 64788",
    d: "M2674.342,572.893c-21.057-48.02-82.173-84.3-138.547-105.688-18.9-7.131-37.542-13.375-55.794-18.662-100.445-29.157-185.3-35.329-284.562-16.5-89.322,16.6-186.183,55.55-298.415,95.379-34.336,12.306-69.758,24.211-105.7,35.632-122.554,38.769-252.07,71.772-378.271,94.614q-47.366,8.582-94.659,15.044C1115.7,699.854,914.53,693.386,749.263,649.03c-117.207-31.2-218.486-81.878-358.03-105.556-56.69-9.6-117.359-12.8-177.776-14.547-33.7-.972-67.608-1.476-101.524-1.488-150.516-.035-313.769,1.758-400.261-33.706",
    transform: "translate(17.015 63.457)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64789",
    "data-name": "Tracciato 64789",
    d: "M2689.093,607.334c-17.559-50.77-77.732-90.476-133.488-115.537q-28.034-12.542-55.343-22.583c-100-36.745-187.073-51.952-289.443-40.491-92.139,9.993-192.27,43.838-306.049,80.755-34.787,11.4-70.534,22.652-106.7,33.637-123.372,37.315-252.542,71.339-378.67,96.346q-47.341,9.395-94.615,16.877c-202.559,31.5-404.179,31.992-573.775-3.3-120.3-24.788-226.406-67.966-367.048-88.025-57.14-8.134-117.877-10.7-178.4-12.176-33.76-.822-67.719-1.291-101.683-1.389-150.687-.419-315.018-1.951-400.639-46.96",
    transform: "translate(15.314 64.2)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64790",
    "data-name": "Tracciato 64790",
    d: "M2703.845,642.4c-14.061-53.517-73.292-96.651-128.429-125.384q-27.717-14.389-54.895-26.5c-99.56-44.332-188.844-68.576-294.324-64.481-94.956,3.391-198.354,32.128-313.683,66.131-35.236,10.5-71.308,21.092-107.686,31.641-124.188,35.861-253.013,70.906-379.069,98.076q-47.318,10.208-94.569,18.711c-202.431,35.849-404.5,43.307-578.424,17.08C629.376,639.287,518.439,603.615,376.7,587.175c-57.589-6.666-118.393-8.6-179.022-9.806-33.823-.673-67.828-1.107-101.842-1.291-150.858-.8-316.265-5.659-401.017-60.213",
    transform: "translate(13.612 64.322)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64791",
    "data-name": "Tracciato 64791",
    d: "M2718.6,677.986c-10.562-56.267-68.853-102.828-123.371-135.232q-27.4-16.235-54.445-30.423c-99.117-51.92-190.617-85.2-299.205-88.47-97.775-3.21-204.44,20.419-321.318,51.508-35.686,9.59-72.083,19.532-108.677,29.646-125,34.408-253.484,70.472-379.468,99.808-31.53,7.346-63.052,14.259-94.525,20.544-202.3,40.2-404.82,54.622-583.072,37.46-126.479-11.975-242.245-40.142-385.084-52.963-58.039-5.2-118.911-6.5-179.645-7.436q-50.831-.784-102-1.193c-151.03-1.188-317.513-9.365-401.395-73.464",
    transform: "translate(11.91 63.916)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64792",
    "data-name": "Tracciato 64792",
    d: "M2733.348,714c-7.065-59.015-64.412-109-118.312-145.081q-27.082-18.079-54-34.342c-98.674-59.507-192.389-101.822-304.086-112.458C2156.361,412.306,2046.429,430.827,1928,459c-36.136,8.685-72.858,17.972-109.669,27.651-125.82,32.954-253.955,70.04-379.868,101.539-31.514,7.889-63.016,15.418-94.48,22.378-202.172,44.555-405.14,65.936-587.72,57.839-129.57-5.567-250.164-26.23-394.1-35.432-58.489-3.728-119.43-4.394-180.269-5.067q-50.927-.559-102.162-1.094c-151.2-1.572-318.761-13.074-401.772-86.717",
    transform: "translate(10.209 63.087)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64793",
    "data-name": "Tracciato 64793",
    d: "M2748.1,750.38c-3.566-61.763-59.972-115.18-113.252-154.929q-26.767-19.925-53.546-38.263c-98.231-67.094-194.161-118.445-308.968-136.447-103.411-16.414-216.611-3-336.587,22.26-36.586,7.779-73.631,16.412-110.659,25.655-126.636,31.5-254.426,69.607-380.266,103.272-31.5,8.43-62.98,16.574-94.436,24.211-202.042,48.908-405.46,77.251-592.368,78.218-132.66.841-258.083-12.317-403.118-17.9-58.94-2.258-119.947-2.293-180.891-2.7q-51.024-.334-102.322-1c-151.374-1.955-320.009-16.781-402.149-99.969",
    transform: "translate(8.508 61.89)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64794",
    "data-name": "Tracciato 64794",
    d: "M2762.85,787.089c-.069-64.513-55.531-121.356-108.194-164.777q-26.448-21.771-53.1-42.183c-97.788-74.681-195.932-135.069-313.848-160.436-106.228-23.015-222.7-14.711-344.221,7.637-37.037,6.874-74.406,14.852-111.651,23.659-127.452,30.048-254.9,69.174-380.665,105-31.483,8.972-62.945,17.732-94.39,26.046C1154.87,635.3,951,670.6,759.769,680.634c-135.753,7.247-266.005,1.595-412.137-.369-59.39-.79-120.464-.192-181.514-.327q-51.12-.11-102.481-.9c-151.546-2.34-321.257-20.489-402.528-113.223",
    transform: "translate(6.806 60.366)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64795",
    "data-name": "Tracciato 64795",
    d: "M2777.6,824.083c3.429-67.261-51.092-127.531-103.135-174.624q-26.131-23.617-52.647-46.1c-97.346-82.269-197.7-151.691-318.73-184.424-109.045-29.618-228.781-26.423-351.855-6.988-37.486,5.967-75.182,13.293-112.644,21.664-128.268,28.593-255.366,68.74-381.063,106.735-31.467,9.513-62.909,18.888-94.346,27.879C1161.4,625.833,957.082,668.1,761.519,687.2c-138.843,13.655-273.924,15.508-421.155,17.162-59.839.679-120.982,1.909-182.136,2.043q-51.217.115-102.641-.8c-151.716-2.724-322.505-24.2-402.905-126.475",
    transform: "translate(5.104 58.555)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64796",
    "data-name": "Tracciato 64796",
    d: "M2792.354,861.325c6.927-70.011-46.652-133.708-98.076-184.473-17.21-16.975-34.6-33.707-52.2-50.024-96.9-89.855-199.477-168.314-323.611-208.412C2206.605,382.2,2083.6,380.283,1958.979,396.8c-37.937,5.062-75.957,11.733-113.635,19.669-129.084,27.14-255.837,68.308-381.462,108.467-31.45,10.055-62.873,20.044-94.3,29.712-201.654,61.964-406.42,111.194-606.311,139.355C621.336,714.069,481.426,723.427,333.1,728.7c-60.289,2.148-121.5,4.01-182.76,4.413q-51.311.339-102.8-.7c-151.888-3.108-323.753-27.9-403.283-139.728",
    transform: "translate(3.403 56.497)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64797",
    "data-name": "Tracciato 64797",
    d: "M2807.105,898.774c10.424-72.758-42.212-139.883-93.018-194.32-17-18.205-34.23-36.249-51.749-53.945-96.46-97.443-201.248-184.937-328.491-232.4-114.682-42.821-240.953-49.843-367.125-36.235-38.386,4.156-76.731,10.173-114.625,17.674-129.9,25.686-256.308,67.875-381.861,110.2-31.435,10.6-62.837,21.2-94.256,31.546C1174.455,607.607,969.24,663.8,765.021,701.025,620,727.493,475.258,744.357,325.83,753.249c-60.738,3.617-122.017,6.11-183.383,6.784q-51.408.564-102.96-.6c-152.06-3.493-325-31.612-403.66-152.981",
    transform: "translate(1.702 54.232)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64798",
    "data-name": "Tracciato 64798",
    d: "M2821.856,936.4c13.924-75.508-37.771-146.06-87.958-204.169-109.222-126.459-230.647-249.468-384.673-314.255C2196,353.522,2022.3,352.493,1858.851,382.794S1539.234,473.063,1382.379,528.1C947.325,680.761,492.35,798.357,31.438,786.619-120.794,782.741-294.811,751.3-372.6,620.386",
    transform: "translate(0 51.793)",
    fill: "none",
    stroke: "#13ab9f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome);
export default __webpack_public_path__ + "static/media/bg-home.aa00c92cacd441612aade1a128a9eb99.svg";
export { ForwardRef as ReactComponent };